module.exports = __webpack_public_path__ + "static/media/box_plus.09921d8d.png";